import React, { Component } from 'react';
import ReactIScroll from 'react-iscroll';
import iScroll from 'iscroll';
import InfoBlockMiami from './InfoBlockMiami';
import StoryMiami from './StoryMiami';
import RowButtonMiami from './RowButtonMiami';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import NavButtonMiami from './NavButtonMiami';
import BackButtonMiami from './BackButtonMiami';
import miamiConstants from './MiamiConstants';
import ScrollSpacer from './ScrollSpacer';
import VideoMiami from './VideoMiami';
import { connect } from 'react-redux';
import _ from 'lodash';
import { dp, presetDp } from '../../../utils/shared.js';
import Moment from 'react-moment';
import shared from '../../../utils/shared';

class StoriesMiami extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      iScrollInitialized: false,
      story: null,
    };

    const type = _.get(this.props.module.contents, 'custom_fields.folder_type.val.value', null);
    this._model = type;
    if (type === "videos") {
      this._mode = "video";
    }

    // this._mode = this.props.module.contents.custom_fields.stories_type.val;
    this._modalTimeout = null;

    this._subscribeModule = null;
    this._rowWrapper = null;
    this._arrowIcon = null;
    this._colorPallette = null;

    this.getSubscribeModule();

    // this._dataContent = _.filter(this.props.content.stories, { folder: Number(this.props.module.contents.story_category) })

    this._dataContent = _.orderBy(this.props.module.children, story => {
      return story.sorting_name.toLowerCase();
    });
    
    for (var i = 0; i < this._dataContent.length; i++) {
      this._dataContent[i].index = i;
    }

    this.storyRefs = [];
  }

  componentDidMount() {
    this.checkSwipeAnimation();
  }

  componentWillUnmount() {
    for (let i = 0; i < this.storyRefs.length; i++) {
      this.storyRefs[i].removeEventListener("tap", () => this.handleTap(i));
    }
    clearTimeout(this._modalTimeout);
    this._modalTimeout = null;
  }

  initializeIScroll = () => {
    if (this.state.iScrollInitialized === false) {
      for (let i = 0; i < this.storyRefs.length; i++) {
        this.storyRefs[i].addEventListener("tap", () => this.handleTap(i));
      }

      this.setState({
        iScrollInitialized: true
      })
    }
  }

  checkSwipeAnimation = () => {
    const wrapperHeight = this._wrapperDiv.getBoundingClientRect().height;
    const contentHeight = this._innerDivRef.getBoundingClientRect().height;
    if (this._dataContent.length > 12) {
      this.props.handleSwipeAnimation(wrapperHeight, contentHeight);
    }
  }

  handleScrollStart = () => {
    this.props.cancelSwipeAnimation();
  }

  handleTap = (index) => {
    this.props.cancelSwipeAnimation();
    if (this._mode === "video") {
      if (this.props.screensNumber <= 1) {
        this.props.showNavButton(false);
      }
      this.setState({
        contentIndex: index,
        content: this._dataContent[index],
        showModal: true
      });
    } else {
      if (this.state.showModal) {
        this.setState({
          showModal: false
        });
  
        clearTimeout(this._modalTimeout);
        this._modalTimeout = null;
        this._modalTimeout = setTimeout(() => {
          this.setState({
            contentIndex: index,
            content: this._dataContent[index],
            showModal: true
          });
        }, 500);
      } else {
        this.setState({
          contentIndex: index,
          content: this._dataContent[index],
          showModal: true
        }); 
      }
    }
  }

  handleNext = () => {
    let nextIndex = shared.loopIndex(this.state.contentIndex, 0, this._dataContent.length - 1, 'forward');
    this.setState({
      contentIndex: nextIndex,
      content: this._dataContent[nextIndex],
      showModal: true
    });
  }

  handlePrevious = () => {
    let previousIndex = shared.loopIndex(this.state.contentIndex, 0, this._dataContent.length - 1, 'backward');
    this.setState({
      contentIndex: previousIndex,
      content: this._dataContent[previousIndex],
      showModal: true
    });
  }

  handleBack = () => {
    this.props.showNavButton(true);
    this.setState({
      showModal: false
    })
  }

  renderStories = () => {
    let learnMoreButton = "/img/miami/general/learnmore_grad_button.png";
    if (this._colorPallette === "adaptive") {
      learnMoreButton = "/img/miami/general/learnmore_grad_button_green.png"
    }
    let storySets = [];
    let setCount = 0;
    for (var i = 0; i < this._dataContent.length; i++) {
      if (!storySets[setCount]) {
        storySets[setCount] = [];
      }
      storySets[setCount].push(this._dataContent[i]);
      if ((i + 1) % 3 === 0 && i !== 0) {
        setCount++
      }
      if (i === 2) {
        storySets[setCount++] = [] //empty entry for spacer row
      }
    }
    const renderedStorySets = storySets.map((row, i) => {
      if (i === 1) {
        return (
          <div key={i}>
            <RowButtonMiami
              buttonEvent={this.redirect}
              header="Be the Change"
              message="Help make a difference by becoming a donor."
              button={learnMoreButton}
            />
          </div>
        )
      }
      return (
        <div key={i}>
          <div style={{ marginBottom: this.props.screen.r9_16.p10 * .17, display: 'flex', alignItems: 'flex-start' }}>
            {this.renderRow(row, i)}
          </div>
          <div>
            {storySets.length <= 1 ? 
            <div>
              <RowButtonMiami
                buttonEvent={this.redirect}
                header="Get Involved"
                message="Learn about the many ways you can help."
                button={learnMoreButton}
              />
            </div>
              :null
            }
          </div>
        </div>
      )
    });

    return renderedStorySets;

  }

  renderGroupedStories = () => {
    // First get common dates 
    let groupedStories = _(this._dataContent)
    .groupBy(x => x.contents.custom_fields.group_by.val)
    .map((value, key) => ({group_by: key, stories: value}))
    .orderBy(y => y.group_by, ['desc'])
    .value();

    let rowButtonMiamiInserted = false;

    return (
      groupedStories.map((group, groupIndex) => {
        let storySets = [];
        let setCount = 0;

        for (var i = 0; i < group.stories.length; i++) {
          if (!storySets[setCount]) {
            storySets[setCount] = [];
          }
          storySets[setCount].push(group.stories[i]);
          if ((i + 1) % 3 === 0 && i !== 0) {
            setCount++
          }
          if (i === 2) {
            storySets[setCount++] = [] //empty entry for spacer row
          }
        }

        let header = (
          <div style={{ marginLeft:"auto", marginRight:"auto", width:"100%" }}>
            <span style={{color:"white", fontWeight:"bold", fontSize:"1.35vh", width:"100%" }}>
              <Moment format="MMMM YYYY">
                {group.group_by}
              </Moment>
            </span>
            <hr style={{ backgroundColor:"white" }}/>
          </div>
        );

        let renderedStorySets = (
          storySets.map((row, i) => {
            if (i === 1 && rowButtonMiamiInserted === false) {
              rowButtonMiamiInserted = true;
              return (
                <div key={i}>
                  <RowButtonMiami
                    buttonEvent={this.redirect}
                    header="Be the Change"
                    message="Help make a difference by becoming a donor."
                    button="/img/miami/general/learnmore_grad_button.png"
                  />
                </div>
              )
            }

            let renderedStoryset = (
              <div key={i}>
                <div style={{ marginBottom: this.props.screen.r9_16.p10 * .17, display: 'flex', alignItems: 'flex-start' }}>
                  {this.renderRow(row, i)}
                </div>
                <div>
                  {(storySets.length <= 1 && rowButtonMiamiInserted === false) ?
                  <div>
                    <RowButtonMiami
                      buttonEvent={this.redirect}
                      header="Get Involved"
                      message="Learn about the many ways you can help."
                      button="/img/miami/general/learnmore_grad_button.png"
                    />
                  </div>
                    : null
                  }
                </div>
              </div>
            );

            if (storySets.length <= 1) {
              rowButtonMiamiInserted = true;
            }

            return renderedStoryset;
          })
        );
        return (
          <div key={groupIndex}>
            {header}
            {renderedStorySets}
          </div>
        );
      })
    )
  }

  renderRow = (row) => {
    if (row.length === 0) {
      return null;
    }
    return (
      row.map((innerrow, i) => {
        return (
          <div key={i} style={{ display: 'inline-block' }}>
            {this.renderStory(innerrow, i)}
          </div>
        )
      })
    )
  }

  renderStory = (row, i) => {
    const unit = this.props.screen.r9_16.p10 / this.props.screensNumber;
    const image = presetDp("story_pill_thumbnail", _.get(row, 'contents.images[0]', {path: '/img/ui/', file_name: 'image_default.png'}), this.props.screen);
    let mult = .8
    return (
      <div ref={el => this.storyRefs[row.index] = el} style={{ marginRight: unit * .175, display: 'inline-block' }}>
        <InfoBlockMiami
          imgsrc={image}
          imageHeight={unit * 2 * mult}
          infoHeight={"4.6875vh"}
          width={"15vh"}
          unit={unit * mult}
          text={row.name}
          infoColor={"black"}
          infoBackgroundColor={'white'}
          fontFamily={'opensans-regular'}
          fontSize={unit * 0.15}
          arrowIcon={this._arrowIcon}
        />
      </div>
    )
  }

  renderBackButton = () => {
    if (this._mode === "video") {
      return (<NavButtonMiami unit={this.props.screen.r9_16.p10} width={this.props.screen.r9_16.p10 * .7} height={this.props.screen.r9_16.p10 * .7} clickAction={this.handleBack} text={'back'} mode={this._mode} right='1.69270833333333333333vh' top='92%'>
        <div style={{ textAlign: 'center', marginTop: this.props.screen.r9_16.p10 * 0.041666667 }}>
          <span style={{ fontSize: "2.8125vh", color: 'white', fontWeight: 'bold' }}>X</span>
        </div>
      </NavButtonMiami>);
    } else {
      if (this.props.screensNumber === 1) {
        return (
          <BackButtonMiami 
            colorPallette={this._colorPallette}
            backButton={this._arrowIcon}
            unit={this.props.screen.r9_16.p10 / this.props.screensNumber} 
            width="3.90625vh"
            height={miamiConstants.backButtonHeight}
            top="56.46875vh"
            border="0.84375vh"
            clickAction={this.handleBack} 
            text={'back'} 
            mode={this._mode}>
          </BackButtonMiami>
        );
      }

      return null;
    }
  }

  getBackgroundImage = () => {
    const defaultImg = { path:'/img/miami/general/', file_name:'default_single_screen.jpg' }
    if (this.props.screensNumber === 2) {
      defaultImg.file_name = 'default_double_screen.jpg';
    }
    return dp(this.props.screen, _.get(this.props.module, 'contents.images[2]', null));
  }

  getIconImage = () => {
    const defaultImg = { path:'/img/miami/general/', file_name:'default_single_screen.jpg' }
    if (this.props.screensNumber === 2) {
      defaultImg.file_name = 'default_double_screen.jpg';
    }
    return dp(this.props.screen, _.get(this.props.module, 'contents.images[1]', null));
  }

  getModalContent = () => {
    if (this._mode === "video") {
      return (
        <VideoMiami 
          key={this.state.contentIndex}
          screen={this.props.screen}
          screensNumber={this.props.screensNumber}
          content={this.state.content}
          clickAction={this.handleBack}
          tapAction={this.handleTap}
          contentIndex={this.state.contentIndex}
          donorsData={this._dataContent}
          module={this.props.module}
          handlePrevious={this.handlePrevious}
          handleNext={this.handleNext}
        />
      )
    }
    else {
      let showBackground = this.props.screensNumber > 1 ? false : true;
      return (
        <StoryMiami 
          showBackground={showBackground}
          screen={this.props.screen}
          screensNumber={this.props.screensNumber}
          navRoute={this.props.navRoute}
          stories={this._dataContent}
          background={this.getBackgroundImage()}
          mode={this._mode}
          clickAction={this.handleBack}
          contentIndex={this.state.contentIndex}
        />
      )
    }
  }

  getSubscribeModule = () => {
    const rootFolderId = _.get(this.props.content, 'settings.selected_root_folder', null);
    const menu = this.props.content.story_categories.find(folder => {
      const type = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
      return folder.parent_category === Number(rootFolderId) && type === "menu";
    });
    const rootFolder = this.props.content.story_categories.find(folder => folder.id === Number(rootFolderId));
    this._arrowIcon = dp(this.props.screen, _.get(menu, 'contents.images[0]', null), null);
    this._colorPallette = _.get(rootFolder, 'contents.custom_fields.color_pallette.val.value', 'golisano');
    const subscribeModule = this.props.content.story_categories.find(folder => {
      const type = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
      return folder.parent_category === Number(menu.id) && type === "be_the_change";
    });
    this._subscribeModule = subscribeModule;
  }

  redirect = () => {
    if (this._subscribeModule !== null && this._subscribeModule !== undefined) {
      this.props.navRoute('/miami/subscribe', this._subscribeModule);
    }
  }

  render() {
    // return null;
    const unit = this.props.screen.r9_16.p10 * .25;
    const backgroundImage = this.getBackgroundImage();
    const iconImage = this.getIconImage();
    const backgroundSize = `${this.props.screen.screenWidth}px ${this.props.screen.screenHeight}px`;

    let modalStyle= {
      position:"absolute", 
      width: this.props.screen.screenWidth / this.props.screensNumber, 
      left: this.props.screensNumber === 1 ? 0:this.props.screen.screenWidth / this.props.screensNumber
    }

    return (
      <div style={{ width: this.props.screen.screenWidth, height: this.props.screen.r9_16.height, backgroundImage: "url("+backgroundImage+")", backgroundSize: backgroundSize }} >
        <div style={{ position:"absolute", width: this.props.screen.screenWidth / this.props.screensNumber }} >
          <div>
            <div style={{ position:"absolute", width: this.props.screen.screenWidth / this.props.screensNumber }} >
              <div style={{ position:"absolute", display: "block", marginLeft: "auto", textAlign: "center", marginRight: "auto", width: '100%' }}>
                <div style={{ height: "4vh" }}>
                </div>
                <img alt={this.props.module.name} src={iconImage} style={{ width: '16vh' }} />
              </div>
              <div style={{ position:"absolute", top:"16vh", fontFamily: 'opensans-extrabold', textAlign: "center", fontSize: '3.6vh', width: "100%", overflow:"hidden" }}>
                {this.props.module.name.toUpperCase()}
              </div>
              <div style={{ width:"100%", position:"absolute", top:"21vh", display: "flex", justifyContent: "center", overflow:"hidden", minHeight:"2.6041666666666666666vh", maxHeight: "5.20833333333333333333vh" }}>
                <div style={{ fontFamily: 'opensans-regular', fontSize: '1.6851vh', textAlign: "center", width:"85%" }}>
                  {this.props.module.description}
                </div>
              </div>
              <div style={{ height: '4.8109375vh' }} />
              <div className="topgradblackP25" style={{ position:"absolute", width: '100%', height: "2.8125vh", top:"26.979166667vh" }} />
              <div style={{ width: "100%", display:"flex", justifyContent:"center" }}>
                <div ref={el => this._wrapperDiv = el} style={{ position:"absolute", top: "28.64583333333333333333vh", color: 'black', width: '85%', height: "73vh", display: "block", marginLeft: "auto", marginRight: "auto", marginTop:"-1.6875vh", touchAction:"none" }}>
                  <ReactIScroll ref={el => this.iScroller = el} iScroll={iScroll}
                    onScrollStart={this.handleScrollStart}
                    options={{
                      mouseWheel: true,
                      scrollbars: false,
                      scrollX: false,
                      scrollY: true,
                      probeType: 2,
                      bounce: false,
                      momentum: true,
                      deceleration: 0.005,
                      useTransition: true,
                      disableTouch: false,
                      disablePointer: false,
                      disableMouse: false,
                      tap: true
                    }}
                    onRefresh={this.initializeIScroll}
                  >
                    <div ref={el => this._innerDivRef = el}>
                      <div style={{ height:"3.5vh" }}></div>
                      {
                        this.props.module.isGrouped ?
                        this.renderGroupedStories() :
                        this.renderStories()                      
                      }
                      <ScrollSpacer unit={unit} />
                    </div>
                  </ReactIScroll>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div style={{ ...modalStyle }}>
          <CSSTransitionGroup
            component='div'
            className="containerFade"
            style={{ minHeight: '100%' }}
            transitionName='example'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.showModal}>
              {this.state.showModal ? this.getModalContent() : null}
              {this.state.showModal ? this.renderBackButton() : null}
            </div>
          </CSSTransitionGroup >
        </div>
      </div>
      
    )
  }
}

const mapStateToProps = (state) => {

  return {
    content: state.content,
    screen: state.screen
  };
};

export default connect(mapStateToProps, null)(StoriesMiami);


// WEBPACK FOOTER //
// ./src/Components/Theme/Miami/StoriesMiami.js